import React, { useEffect, useState } from 'react';
import RecurringSessionsList from 'containers/pages/sessions/RecurringSessionsList';
import { generatePath, useHistory, useParams } from 'react-router-dom';
import { ROUTE_SESSIONS_ENTITY_SESSION } from 'routes/RouteList';
import { useSessionsContext } from 'contexts/SessionsContext';
import messages from 'messages';
import { useIntl } from 'react-intl';
import Session from 'models/Session';
import { TestSetV2Type } from 'constants';
import AddSessionModal from 'containers/pages/sessions/AddSessionModal';
import { useContextMenu } from 'contexts/ContextMenuProvider';
import { useAbility } from '@casl/react';
import { AbilityContext } from 'Can';
import { ButtonExpandable } from 'components/button';

const OverviewRecurringTab = () => {
  const intl = useIntl();
  const { push } = useHistory();
  const ability = useAbility(AbilityContext);
  const { entityId } = useParams();
  const { recurringSessions } = useSessionsContext();
  const [sessionModal, setSessionModal] = useState(null);

  const { addActionButton, clearAllContext } = useContextMenu();

  useEffect(() => {
    if (ability.can('create', 'RecurringSessions')) {
      addActionButton(
        <ButtonExpandable
          tabIndex={0}
          onClick={onClickNewRecurringSessionHandler}
          label={intl.formatMessage(messages.titleRecurringSessionsNewSession)}
        />
      );
    }

    return () => {
      clearAllContext();
    };
  }, [recurringSessions]);

  const onSessionClickHandler = (session, tab) => {
    push(
      generatePath(ROUTE_SESSIONS_ENTITY_SESSION, {
        entityId,
        sessionsTab: tab,
        sessionId: session.id
      })
    );
  };

  const onClickNewRecurringSessionHandler = () => {
    setSessionModal({
      title: intl.formatMessage(messages.titleRecurringSessionsNewSession),
      type: 'recurring',
      session: new Session({
        recurring: true,
        type: TestSetV2Type.TALENT
      })
    });
  };

  if (!recurringSessions || recurringSessions.length === 0) {
    return null;
  }

  return (
    <>
      <RecurringSessionsList
        onClick={session => onSessionClickHandler(session, 'recurring')}
      />

      {sessionModal && (
        <AddSessionModal
          entityId={entityId}
          title={sessionModal.title}
          type={sessionModal.type}
          isCopy={sessionModal.isCopy}
          session={sessionModal.session}
          onClose={() => {
            setSessionModal(false);
          }}
        />
      )}
    </>
  );
};

export default OverviewRecurringTab;
